import React from 'react';
import './Styles/ContactForm.scss';
import Input from '../../Shared/Input/Input';
import { contactData } from './data';
const ContactForm=()=>{
    return(
        <div className="contactus">
            <h1>Contact Us</h1>
            <p>Looking for help? Fill the form below or email us. We will respond you as soon as possible.</p>
            <div className="contact-main">
            <div className="form-container">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12632.12567900777!2d-122.12583330248351!3d37.67196949360618!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808f9431b601597d%3A0x70474dec26939c0!2sHayward%2C%20CA%2C%20USA!5e0!3m2!1sen!2s!4v1625393182149!5m2!1sen!2s" width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" tabindex="0"></iframe>
            <div className="forms">
                <div className="inputs">
                    <Input 
                    label="First Name"
                    type="text"
                    />
                    <Input 
                    label="Last Name"
                    type="text"
                    />
                </div>
                <Input 
                    label="Work Email Address"
                    type="email"
                    />
                    <fieldset className="textfield">
                        <legend>
                            Comment
                        </legend>
                        <textarea cols={12} rows={10} ></textarea>
                    </fieldset>
                    <button>Send Message</button>
            </div>
            </div>
            <ul>
                {contactData.map((item) =>{
                    return(
                        <li>
                            <div className="icon">
                                {item.icon}
                            </div>
                            <div className="info">
                                <h3>{item.title}</h3>
                                <p>{item.desc}</p>
                            </div>
                        </li>
                    )
                })}
            </ul>
            </div>
        </div>
    )
};
export default ContactForm;